import React from 'react'

import { Colors } from './Colors';

export default function Logo() {
  return (
    <div style={{
        color: Colors.Light,
        fontSize: "50px",
        lineHeight: "50px",
    }}>
      REACTRIS
    </div>
  )
}
